import { useSearchParams } from 'react-router-dom';

export function useCurrentPage(): number {
  const [params] = useSearchParams();
  const value = params.get('page');
  if (!value) {
    return 1;
  }
  const res = parseInt(value, 10);
  if (isNaN(res)) {
    return 1;
  }
  return res;
}

export function useSetCurrentPage() {
  const [params, setParams] = useSearchParams();
  return (num: number) => {
    if (num > 1) {
      params.set('page', `${num}`);
    } else {
      params.delete('page');
    }
    setParams(params);
  };
}
